import localize from "../../../common/localize";
import {
  getValueInCurrency,
  getPaymentTypeModeLabel,
} from "../../../common/utils";
import {
  getCurrencyFromSetup,
  getSettlementStatusName,
} from "../../../common/EntitiesManagement";

export const SETTLED_STATUSES = [1, 3]; // Approved, Payed

export const isSettled = (item) => SETTLED_STATUSES.includes(item?.Status);

export const truncateId = (item) => {
  const uuid = item?.id ?? item?.Uuid;
  return uuid ? `${uuid}`.split("-")[0] : "";
};

export const getConceptText = (item) => {
  const currency = getCurrencyFromSetup();
  if (item?.settlementType === 2) {
    const act = item?.additionalCostType;
    if (!act?.Name) return localize.no_data;
    const modeLabel = getPaymentTypeModeLabel(act.PaymentMode);
    const base = modeLabel ? `${act.Name} (${modeLabel})` : act.Name;
    const pt = act.paymentType;
    if (!pt?.Name) return base;
    const isPercentage = pt.Type === 1;
    const typeName = isPercentage
      ? localize.percentage_value
      : localize.fixed_value;
    const val = isPercentage
      ? `${pt.DefaultValue ?? 0}%`
      : getValueInCurrency(currency, pt.DefaultValue ?? 0);
    return `${base} / ${pt.Name} (${typeName}: ${val})`;
  }
  const source = item?.paymentType;
  if (!source?.Name) return localize.no_data;
  const isPercentage = source.Type === 1;
  const typeName = isPercentage
    ? localize.percentage_value
    : localize.fixed_value;
  const val = isPercentage
    ? `${source.DefaultValue ?? 0}%`
    : getValueInCurrency(currency, source.DefaultValue ?? 0);
  return `${source.Name} (${typeName}: ${val})`;
};

export const getSettledTotal = (items) =>
  (items ?? [])
    .filter(isSettled)
    .reduce((sum, item) => sum + (item?.value ?? 0), 0);

// Single receipt detail line: "{uuid} - {concept} · {status} · {base}" on the
// left, value on the right, vertically centered. Rows alternate background
// (zebra striping) based on the provided index. When showObservations is true,
// the detail's observation is shown below the concept, indented for readability.
export function SettlementReceiptLine({ item, index = 0, showObservations = false }) {
  const currency = getCurrencyFromSetup();
  return (
    <div
      style={{
        padding: "3px 12px",
        backgroundColor: index % 2 === 0 ? "#F3F4F6" : "#FFFFFF",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <span
            className="report_little_text"
            style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
          >
            {`${truncateId(item)} - ${getConceptText(item)} · ${getSettlementStatusName(
              item?.Status,
            )} · ${localize.settlement_base_value}: ${getValueInCurrency(
              currency,
              item?.baseValue ?? 0,
            )}`}
          </span>
          {showObservations && item?.Observations && (
            <div
              className="report_little_text"
              style={{
                paddingLeft: "24px",
                color: "#4B5563",
                whiteSpace: "pre-line",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {`${localize.observations}: ${item.Observations}`}
            </div>
          )}
        </div>
        <span
          className="report_little_text"
          style={{
            whiteSpace: "nowrap",
            textAlign: "right",
            marginLeft: "auto",
            flexShrink: 0,
          }}
        >
          {getValueInCurrency(currency, item?.value ?? 0)}
        </span>
      </div>
    </div>
  );
}
